import { useMutation } from 'react-query';

import { roleUpdateByID as mutationFn } from 'api/endPoints/roleUpdateByID';

export const useMutationUpdateRole = () => {
    return useMutation<any, QueryError, { role: IRoleNew; id: string }>((params) => mutationFn(params));
};
